// Analytics + consent helper (CCPA opt-out model).
// Pixels (GA4 + LinkedIn) run by default; a visitor can Decline to turn them off.
const GA_ID = "G-F0RHYR7YS8";
const KEY = "reelty_consent"; // 'granted' | 'denied' | null(undecided → tracking on)

// When you have LinkedIn Campaign Manager conversion IDs, map them here, e.g.
// { start_trial: 12345678, purchase: 12345679 }. Empty → fires a generic signal.
const LI_CONVERSIONS = {};

export function getConsent() {
  try { return localStorage.getItem(KEY); } catch { return null; }
}

// Opt-out: allowed unless the visitor explicitly declined.
export function trackingAllowed() {
  return getConsent() !== "denied";
}

export function applyConsent(value) {
  const granted = value === "granted";
  const state = granted ? "granted" : "denied";
  try {
    if (window.gtag) {
      window.gtag("consent", "update", {
        ad_storage: state, analytics_storage: state,
        ad_user_data: state, ad_personalization: state,
      });
    }
  } catch { /* noop */ }
  window[`ga-disable-${GA_ID}`] = !granted;
}

export function setConsent(value) {
  try { localStorage.setItem(KEY, value); } catch { /* noop */ }
  applyConsent(value);
}

// Re-apply a stored "denied" choice on every load so GA stays off for decliners.
export function initConsent() {
  if (getConsent() === "denied") applyConsent("denied");
}

export function track(event, params = {}) {
  if (!trackingAllowed()) return;
  try { window.gtag && window.gtag("event", event, params); } catch { /* noop */ }
  try {
    if (window.lintrk) {
      const cid = LI_CONVERSIONS[event];
      window.lintrk("track", cid ? { conversion_id: cid } : {});
    }
  } catch { /* noop */ }
}
